function getStepFieldSettings(step) {
  switch (step.type) {
    case 'radio-group':
    case 'checkbox-group':
      return step.field;
    case 'rating':
      return step.ratingSettings;
    case 'select-region':
      return step.selectRegionSettings;
    default:
      return null;
  }
}
function getStepFieldName(step) {
  var _a, _b;
  return (_b = (_a = getStepFieldSettings(step)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
}
export { getStepFieldName, getStepFieldSettings };